import { AnimatePresence, motion } from 'motion/react'
import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router'

import { Footer } from './components/Footer'
import { Nav } from './components/Nav'
import { CatalogProvider } from './lib/catalog'
import { About } from './pages/About'
import { Admin } from './pages/Admin'
import { Home } from './pages/Home'
import { Product } from './pages/Product'
import { Shop } from './pages/Shop'

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    // "/#kategoriyalar" style links jump to a section of the home page once it
    // has mounted; a plain navigation starts at the top.
    const target = hash ? document.getElementById(hash.slice(1)) : null
    const timer = window.setTimeout(() => {
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      else window.scrollTo({ top: 0 })
    }, hash ? 60 : 0)
    return () => window.clearTimeout(timer)
  }, [pathname, hash])
  return null
}

function Pages() {
  const location = useLocation()
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
        className="min-h-[70vh]"
      >
        <Routes location={location}>
          <Route index element={<Home />} />
          <Route path="shop" element={<Shop />} />
          <Route path="product/:slug" element={<Product />} />
          <Route path="about" element={<About />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
  )
}

function Storefront() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <Pages />
      <Footer />
    </>
  )
}

export function App() {
  return (
    <CatalogProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="*" element={<Storefront />} />
        </Routes>
      </BrowserRouter>
    </CatalogProvider>
  )
}